<template>
  <div class="hint-block">
    <div>
      <img
        src="~@/assets/img/icons/warn-icon.svg"
        style="width: 24px"
      >
    </div>
    <div class="hint-block__text">
      <div
        v-if="false"
        class="hint-block__title"
      >
        Примечание:
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.hint-block {
  background-color: #EEEFF1;
  border-radius: 10px;
  padding: 20px;
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-column-gap: 16px;
  align-items: center;

  &__title {
    font-weight: 600;
    margin-bottom: 5px;
  }

  &__text {
    color: #161C21;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.14px;
  }
}
</style>
